export const exportJobName = {
  // asset
  asset: "Asset", // common
  assetUnderwriter: "Asset Underwriter",
  assetAudit: "Asset Audit",
  assetDocumentData: "Asset Documents Data",
  assetFileArchives: "Asset File Archives",

  // tsa billing
  tsaBilling: "TSA Billing",

  //tranche
  trancheDocumentExport: "Tranche Data",

  //contact
  contactDocumentExport: "Contacts Data",
  tsaAndOmaDocumentExport: "Contacts TSA and OMA Document",

  // production report
  productionReport: "Production Report",
  assetEstimationProductionReport: "Asset Estimation Production Report",
  productionReportsv2Report: "Production Report V2",
  productionReportMonitoring: "Production Report Monitoring",
  energizedAssetMissingPvWatts: "Energized Assets Missing PVWatts",
  interactions: "Interactions",
};
